import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { ActivationEnd, Router } from "@angular/router";
import { TitleService } from "./title.service";
import { filter, map, debounceTime } from "rxjs/operators";
import { NotificationService } from "./notifications/notification.service";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { Notification } from "./notifications/notification";
import { SessionService } from "./session.service";
import { SidebarService } from "./sidebar/sidebar.service";
import { Subject } from "rxjs";

const TITLE = "Lighthouse";
const TITLE_PREFIX = "Lighthouse | ";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  faCheckCircle = faCheckCircle;
  notificationsOpen = false;
  private onComponentDestroy = new Subject();
  constructor(
    private router: Router,
    private titleService: TitleService,
    private NotificationService: NotificationService,
    private SessionService: SessionService,
    private SidebarService: SidebarService,
    public viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit() {
    // this.watchRouteNavigationChanges();
    this.watchRouteNavigationEnd();
    this.NotificationService.toggleNotificationsEvent.subscribe(() => {
      this.notificationsOpen = !this.notificationsOpen;
    });
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get notifications() {
    return this.NotificationService.notifications;
  }

  get currentUserValue() {
    return this.SessionService.currentUserValue;
  }

  get userLoggedIn() {
    return !!this.currentUserValue;
  }

  get isDocsRoute() {
    return this.router.url.startsWith("/docs");
  }

  get hideNavBar() {
    return !this.userLoggedIn || this.isDocsRoute;
  }

  markAllRead() {
    this.NotificationService.markAllAsRead();
  }

  deleteAll() {
    this.NotificationService.deleteAll();
  }

  deleteNotification(event: MouseEvent, notification: Notification) {
    event.stopPropagation();
    this.NotificationService.deleteNotification(notification);
  }

  openNotification(notification: Notification) {
    //TODO: go to desired notification route
    if (notification.viewed === false) {
      this.NotificationService.markAsRead(notification);
    }
    this.notificationsOpen = false;
  }

  onScrolled() {
    //If already have max default notification per page, get next page
    if (!this.NotificationService.gotAllNotifications) {
      this.NotificationService.getMoreNotifications();
    }
  }

  closeNotifications(event: MouseEvent) {
    this.notificationsOpen = false;
  }

  watchRouteNavigationEnd() {
    let type: string;

    this.router.events
      .pipe(
        filter((event) => event instanceof ActivationEnd),
        debounceTime(100),
        map((event) => (event as ActivationEnd).snapshot),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === "primary"),
        map((route) => (route as any).data),
      )

      .subscribe((event) => {
        this.titleService.setTitle(
          (event as any)["title"]
            ? TITLE_PREFIX + (event as any)["title"]
            : TITLE,
        );

        this.SidebarService.onNavigationRoutesLoaded.subscribe(() => {
          this.SidebarService.setNavigationOpenOnChange((event as any).sidebar);
        });
      });
  }
}
